import { IResult } from '../models/result-models';
import { IPromoDetail } from '../models/talend';
import { apiGet, apiPut } from './api-utils';

const baseUrl = process.env.REACT_APP_API_URL + '/v1/promoDetail';

export const getAll = async (
    billTo: string,
    shipTo: string
): Promise<IResult<IPromoDetail[]>> => {
    const url = baseUrl + '/billTo/' + billTo + '/shipTo/' + shipTo;
    const result = await apiGet<IPromoDetail[]>(url);
    return result;
};

export const release = async (orderNumber: number): Promise<void> => {
    await apiPut(baseUrl + '/release/' + orderNumber, true);
};
